module.exports = __webpack_public_path__ + "static/img/manual_ja_29.e7c7e32.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/ja/manual_ja_29.png
// module id = oZQ5
// module chunks = 4